var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-component',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var touch = ref.touch;
var faulty = ref.faulty;
return [_c('input',_vm._b({ref:"input",staticClass:"inp",class:{faulty: faulty},attrs:{"type":"number","inputmode":"decimal"},domProps:{"value":_vm.intValue},on:{"input":_vm.onInput,"blur":function($event){_vm.onBlur(); touch();}}},'input',_vm.$attrs,false))]}}])},'error-component',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }